module.exports = __webpack_public_path__ + "img/ch.2eb9669a.svg";